import { fade } from "../utils/color.js";
export default function createInputPalette(theme, current, base) {
    return {
        input: {
            color: "inherit",
            backgroundColor: "transparent",
            outline: {
                color: base.text[500],
                backgroundColor: base.background,
                borderColor: current[500],
                disabled: {
                    color: base.gray[400],
                    backgroundColor: base.gray[50],
                    borderColor: base.gray[200],
                    placeholder: {
                        color: base.gray[400],
                    },
                },
                focus: {
                    borderColor: current[500] === base.gray[500] ? fade(base.primary[500], 0.6) : fade(current[500], 0.6),
                    boxShadowColor: current[500] === base.gray[500] ? base.primary[500] : current[500],
                },
                placeholder: {
                    color: base.gray[500],
                },
                group: {
                    borderColor: current[500],
                },
                append: {
                    color: base.gray[500],
                },
                prepend: {
                    color: base.gray[500],
                },
                valid: {
                    backgroundColor: base.background,
                    borderColor: base.success[500],
                    focus: {
                        boxShadowColor: base.success[500],
                    },
                },
                invalid: {
                    backgroundColor: base.background,
                    borderColor: base.error[500],
                    focus: {
                        boxShadowColor: base.error[500],
                    },
                },
            },
            flat: {
                color: current.contrast[100],
                backgroundColor: current[100],
                borderColor: "transparent",
                disabled: {
                    color: base.gray[400],
                    backgroundColor: base.gray[50],
                    borderColor: "transparent",
                    placeholder: {
                        color: base.gray[400],
                    },
                },
                focus: {
                    borderColor: "transparent",
                    boxShadowColor: current[500] === base.gray[500] ? base.primary[500] : current[500],
                },
                placeholder: {
                    color: fade(current.contrast[500], 0.3),
                },
                group: {
                    borderColor: base.gray[500],
                },
                append: {
                    color: base.gray[500],
                },
                prepend: {
                    color: base.gray[500],
                },
                valid: {
                    backgroundColor: base.success[100],
                    borderColor: "transparent",
                    focus: {
                        boxShadowColor: base.success[500],
                    },
                },
                invalid: {
                    backgroundColor: base.error[100],
                    borderColor: "transparent",
                    focus: {
                        boxShadowColor: base.error[500],
                    },
                },
            },
            filled: {
                color: current.contrast[500],
                backgroundColor: current[500],
                borderColor: "transparent",
                disabled: {
                    color: base.gray[400],
                    backgroundColor: base.gray[100],
                    borderColor: "transparent",
                    placeholder: {
                        color: base.gray[400],
                    },
                },
                focus: {
                    borderColor: "transparent",
                    boxShadowColor: current[500] === base.background ? base.primary[500] : current[500],
                },
                placeholder: {
                    color: fade(current.contrast[500], 0.3),
                },
                group: {
                    borderColor: base.gray[600],
                },
                append: {
                    color: base.gray[600],
                },
                prepend: {
                    color: base.gray[600],
                },
                valid: {
                    backgroundColor: base.success[500],
                    borderColor: "transparent",
                    focus: {
                        boxShadowColor: base.success[500],
                    },
                },
                invalid: {
                    backgroundColor: base.error[500],
                    borderColor: "transparent",
                    focus: {
                        boxShadowColor: base.error[500],
                    },
                },
            },
        },
    };
}
//# sourceMappingURL=input.js.map